module.exports = __webpack_public_path__ + "images/de11de92a0080cffaeff9c877c4fdb1eb1dfab9d6c05660ab648bbea3fe7b9eb.svg";